// extracted by css-extract-rspack-plugin
export default {"section":"HvQyj"};